var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7585_9313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3868 5.57046L12.0072 5.31561C12.5118 5.11471 13.163 4.91117 13.9327 5.04055C15.5083 5.30539 16.5954 6.1562 17.2428 7.2847C17.4923 7.7196 17.2908 8.29248 16.8239 8.47534C16.0474 8.77943 15.4999 9.53493 15.4999 10.4162C15.4999 11.3393 16.1009 12.1243 16.9352 12.3969C17.3671 12.5382 17.6098 13.0176 17.4679 13.4493C17.1001 14.5682 16.5697 15.6006 15.9421 16.4339C15.3226 17.2567 14.5658 17.9408 13.7233 18.2743C13.174 18.4918 12.5835 18.4106 12.0189 18.2705L11.6838 18.1813L11.1865 18.0368C10.9607 17.9715 10.7289 17.9148 10.4999 17.9148C10.2709 17.9148 10.0392 17.9715 9.81341 18.0368L9.3161 18.1813L8.98096 18.2705C8.41634 18.4106 7.8259 18.4918 7.27657 18.2743C6.21551 17.8543 5.27961 16.8743 4.57282 15.719C3.85349 14.5431 3.30838 13.0852 3.08613 11.5641C2.89687 10.2687 2.99904 8.81493 3.59844 7.58441C4.21576 6.31713 5.34485 5.33009 7.06717 5.04055C7.767 4.92291 8.3688 5.08044 8.85148 5.261L9.12663 5.37008L9.61308 5.57046C9.94617 5.70098 10.2095 5.77783 10.4999 5.77783C10.7904 5.77783 11.0537 5.70097 11.3868 5.57046ZM10.3064 2.30598C11.12 1.49239 12.3688 1.42209 12.6634 1.71673C12.9581 2.01135 12.8878 3.26015 12.0742 4.07374C11.2606 4.88734 10.0118 4.95763 9.71717 4.663C9.4225 4.36838 9.49284 3.11957 10.3064 2.30598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7585_9313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.daf44a5b1142365ffa8fdf8dbc8caab0.svg";
export { ForwardRef as ReactComponent };